import getCatalogue from "./get";

export default {
  get: getCatalogue,
};
